module.exports = __webpack_public_path__ + "img/icon_1_45.4f56f37b.png";